import { createFileRoute, redirect } from "@tanstack/react-router";

import { getUserFromSession } from "@onesolution/utils";

export const Route = createFileRoute("/app/")({
	beforeLoad: async () => {
		const user = await getUserFromSession();

		if (!user || !user.isAuthenticated) {
			throw redirect({ to: "/login" });
		}

		throw redirect({ to: "/app/operations" });
	},
});
